import React, { useEffect, useState } from "react";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import api from "../../servicos/api";
import "./Unidades.css";

export default function Unidades() {
  const [unidades, setUnidades] = useState([]);

  useEffect(() => {
    async function carregarDados() {
      try {
        const responseUnidades = await api.get(`/api/unidadesAtendimento`);
        setUnidades(responseUnidades.data || []);
      } catch (error) {
        console.error("Erro ao carregar unidades:", error);
      }
    }
    carregarDados();
  }, []);

  function abrirMapa(unidade) {
    if (!unidade?.nome) return;
  
    // hard code brabo
    const overrides = {
      "CLÍNICA CLIUN":
        "https://www.google.com/maps/place/Cliun+-+Cl%C3%ADnica+de+Urologia+de+Natal/@-5.7921057,-35.1978688,17z/data=!3m1!4b1!4m6!3m5!1s0x7b30014682bdd25:0x856dac2d2f477c8f!8m2!3d-5.792111!4d-35.1952939!16s%2Fg%2F1tnl1m21?entry=ttu&g_ep=EgoyMDI1MTIwOC4wIKXMDSoASAFQAw%3D%3D",
  
      "HOSPITAL ANGIOVASCULAR":
        "https://www.google.com/maps/place/Hospital+Geral+AngioVascular/@-5.7923538,-35.2026987,17z/data=!3m1!4b1!4m6!3m5!1s0x7b3001100ec16b5:0x326aecb16eb44bcb!8m2!3d-5.7923591!4d-35.2001238!16s%2Fg%2F1wk6zzzx?entry=ttu&g_ep=EgoyMDI1MTIwOC4wIKXMDSoASAFQAw%3D%3D",
  
      "ROBERTO FREIRE":
        "https://www.google.com/maps/place/Laborat%C3%B3rio+DNA+Center/@-5.8539558,-35.2008195,19.5z/data=!4m6!3m5!1s0x7b2ff3011027327:0x1b8411e45587d585!8m2!3d-5.853865!4d-35.2008183!16s%2Fg%2F11h79tr_4g?entry=ttu&g_ep=EgoyMDI1MTIwOC4wIKXMDSoASAFQAw%3D%3D",
  
      "SANTA CRUZ":
        "https://www.google.com/maps/place/Santa+Cl%C3%ADnica+-+Cl%C3%ADnica+geral+e+Exames+laboratoriais+em+Santa+Cruz/@-6.2259592,-36.022232,18z/data=!4m6!3m5!1s0x7b1fbde04213ccb:0xcbaf52154b429586!8m2!3d-6.2261091!4d-36.0213038!16s%2Fg%2F11yfflwhlj?entry=ttu&g_ep=EgoyMDI1MTIwOC4wIKXMDSoASAFQAw%3D%3D",

      "CARNAUBAIS":
        "https://www.google.com/maps/place/DNA+Center/@-5.3387967,-36.8364484,17.75z/data=!4m6!3m5!1s0x7b0c479c2c56def:0xc6436bd849a68dbc!8m2!3d-5.3389943!4d-36.8350737!16s%2Fg%2F11yb2ch_1t?entry=ttu&g_ep=EgoyMDI1MTIwOC4wIKXMDSoASAFQAw%3D%3D",
    };
  
    // se houver override para esse nome de unidade, usa o link fixo
    const overrideUrl = overrides[unidade.nome];
    if (overrideUrl) {
      window.open(overrideUrl, "_blank");
      return;
    }
  
    // comportamento padrão para o restante
    const prefixo = "Laboratório DNA Center";
    let query = `${prefixo} ${unidade.nome}`;
  
    if (unidade.endereco) {
      query += `, ${unidade.endereco}`;
    }
  
    const url = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
      query
    )}`;
    window.open(url, "_blank");
  }
  

  return (
    <div className="unidades-container">
      <h1 className="unidades-header">Nossas unidades</h1>

      <div className="unidades-list">
        {unidades.map((unidade) => (
          <div key={unidade.id} className="unidade-card">
            <div className="unidade-nome-container">
              <h2 className="unidade-nome">
                <LocationOnIcon 
                  className="pin-icon"
                  onClick={() => abrirMapa(unidade)}
                  title="Abrir no Google Maps"
                />
                <span 
                  className="nome-texto"
                  onClick={() => abrirMapa(unidade)}
                  title="Abrir no Google Maps"
                >
                  {unidade.nome}
                </span>
              </h2>
            </div>
            
            <div className="unidade-info">
              {unidade.endereco && (
                <div className="unidade-campo">
                  <span 
                    className="campo-valor endereco-clickable" 
                    onClick={() => abrirMapa(unidade)}
                    style={{ cursor: 'pointer' }}
                  >
                    {unidade.endereco}
                  </span>
                </div>
              )}

              {unidade.pontoreferencia && (
                <div className="unidade-campo">
                  <span className="campo-valor">{unidade.pontoreferencia}</span>
                </div>
              )}

              {unidade.atendimento && (
                <div className="unidade-campo">
                  <span className="campo-valor horario-atendimento">Horário de atendimento: {unidade.atendimento}</span>
                </div>
              )}

              {unidade.horariocoleta && (
                <div className="unidade-campo">
                  <span className="campo-valor horario-coleta">Horário de coleta: {unidade.horariocoleta}</span>
                </div>
              )}

              {unidade.telefone && (
                <div className="unidade-campo">
                  <span className="campo-valor contato">Contato: {unidade.telefone}</span>
                </div>
              )}

              {unidade.observacoes && (
                <div className="unidade-campo">
                  <span className="campo-valor">{unidade.observacoes}</span>
                </div>
              )}

            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
